import { render, staticRenderFns } from "./BaseOtherInfo.vue?vue&type=template&id=14feff9c&scoped=true&"
import script from "./BaseOtherInfo.vue?vue&type=script&lang=js&"
export * from "./BaseOtherInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseOtherInfo.vue?vue&type=style&index=0&id=14feff9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14feff9c",
  null
  
)

export default component.exports